import React from 'react';

import TileSelector from './TileSelector.js';
import Map from './Map.js';
import { imageForLabel, orientationForLabel, tileTypeForLabel } from './label-lookups';


export default class Builder extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.stateForLabel(this.props.label);

    this.selectTile = this.selectTile.bind(this);
  }

  selectTile(label) {
    this.setState(this.stateForLabel(label));
  }

  stateForLabel(label) {
    return {
      selectedLabel: label,
      selectedImage: imageForLabel(label),
      selectedOrientation: orientationForLabel(label),
      selectedTileType: tileTypeForLabel(label)
    };
  }

  render() {
    return(
      <div className="builder">
        <div>
          <div>
            <div className="builder-left-pane">
              <TileSelector 
                selectedLabel={this.state.selectedLabel}
                onClick={this.selectTile}
              />
            </div>

            <div className="builder-right-pane">
              <Map 
                selectedImage={this.state.selectedImage}
                selectedOrientation={this.state.selectedOrientation}
                selectedTileType={this.state.selectedTileType}
                auth={this.state.auth}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
